import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  size?: 'sm' | 'md' | 'lg';
  rounded?: boolean;
  className?: string;
  onClick?: () => void;
}
const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  rounded = true,
  className = '',
  onClick
}) => {
  // Variant styles
  const variantStyles = {
    primary: 'bg-blue-100 text-blue-800',
    secondary: 'bg-gray-100 text-gray-800',
    success: 'bg-green-100 text-green-800',
    danger: 'bg-red-100 text-red-800',
    warning: 'bg-yellow-100 text-yellow-800',
    info: 'bg-indigo-100 text-indigo-800'
  };
  // Size styles
  const sizeStyles = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-0.5',
    lg: 'text-base px-3 py-1'
  };
  // Rounded styles
  const roundedStyles = rounded ? 'rounded-full' : 'rounded';
  // Combined styles
  const combinedStyles = `
    inline-flex items-center justify-center font-medium
    ${variantStyles[variant]} 
    ${sizeStyles[size]} 
    ${roundedStyles}
    ${onClick ? 'cursor-pointer hover:opacity-80' : ''}
    ${className}
  `;
  return onClick ? <button onClick={onClick} className={combinedStyles} data-id="element-593">
      {children}
    </button> : <span className={combinedStyles} data-id="element-594">{children}</span>;
};
export default Badge;